module.exports = __webpack_public_path__ + "img/fwsjmbanner2.30e24ad3.svg";